import { SET_CATEGORY } from '../constants/constants'

// eslint-disable-next-line default-param-last
const category = (state = {}, action) => {
    if (action.type === SET_CATEGORY) {
        return action.payload
    }

    return state
}

export default category
